import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const Put = (path, data, token) => {
    return Axios({
        method: 'PUT',
        url: baseUrl + path,
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
}

export default Put;